import { render, staticRenderFns } from "./DashboardGBS.vue?vue&type=template&id=5db5ebbe&scoped=true&"
import script from "./DashboardGBS.vue?vue&type=script&lang=js&"
export * from "./DashboardGBS.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGBS.vue?vue&type=style&index=0&id=5db5ebbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db5ebbe",
  null
  
)

export default component.exports